import { render, staticRenderFns } from "./CustomerComplaintCorrectiveDetail.vue?vue&type=template&id=2b38b126&"
import script from "./CustomerComplaintCorrectiveDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerComplaintCorrectiveDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports